var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "stat_minus_1"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_839_5736",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 24,
    y: 24,
    width: 24,
    height: 24,
    transform: "rotate(-180 24 24)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_839_5736)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "stat_minus_1_2",
    d: "M11.9999 9.29798L17.3076 14.6057L16.5999 15.3135L11.9999 10.7192L7.39987 15.3135L6.69212 14.6057L11.9999 9.29798Z",
    fill: "#232323"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDropdown);
export default __webpack_public_path__ + "static/media/close_dropdown.47944db2d0b6bdf379899cc9b36c4396.svg";
export { ForwardRef as ReactComponent };